export const previreconfig = {
    cardWidth: 180,
    colNum: 18,
    rowHeight: 1,
    defaultW: 20,
    dafaultH: 20,
    defaultSize: 14,
    defaultAlign: 2
}

function defaultCardMode(baseCardSize, afterName) {
    console.log("afterName", afterName);
    return {
        tag: "text",
        x: 0,
        y: 0,
        w: baseCardSize.width,
        h: baseCardSize.height,
        fontSize: 14,
        fontWeight: 500,
        color: "#212121",
        wMode: "lr",
        valign: "center",
        textAnchor: "middle",
        lineNums: 2,
        text: (data) => {
            return [data.dname + afterName];
        },
    }
}

export function createPreData(list = []) {
    const cardDimension = [...list]

    let baseIndex = 0

    for (let i = 0; i < cardDimension.length; i++) {
        if (cardDimension[i].carddimensionId == "1010") {
            baseIndex = i
        }
    }

    const baseCardDim = cardDimension.splice(baseIndex, 1)[0]

    const baseData = {
        id: 0,
        dname: baseCardDim.carddimensionName,
        type: baseCardDim.carddimensionId,
        infoIndex: 0,
        children: [
            {
                id: 1,
                dname: baseCardDim.carddimensionName,
                type: baseCardDim.carddimensionId,
                infoIndex: 1
            },
            {
                id: 2,
                dname: baseCardDim.carddimensionName,
                type: baseCardDim.carddimensionId,
                infoIndex: 2
            }
        ]
    }

    let baseID = 3

    for (let i = 0; i < cardDimension.length; i++) {
        const item = cardDimension[i];
        baseData.children.push({
            id: baseID++,
            dname: item.carddimensionName,
            type: item.carddimensionId
        })

    }


    return baseData
}

export function createCardModel(cardDimension, cardstyleMap, baseCardSize, afterName) {
    let maxh = 20
    console.log("cardDimension", cardDimension);

    const cardModelMap = {}
    const cardModelSize = {}
    const orgCardNavbar = {
        tag: "rect",
        x: 0,
        y: 0,
        w: previreconfig.cardWidth,
        h: 2,
        fill: () => "#5582F3"
    }

    cardDimension.map((item) => {
        const itemStyle = cardstyleMap[item.carddimensionId]
        cardModelMap[item.carddimensionId] = []

        if (itemStyle) {
            let MaxHeight = 0
            itemStyle.cardStyleFields.forEach((fieldItem) => {
                
                MaxHeight = Math.max(MaxHeight, (parseInt(fieldItem.high) + parseInt(fieldItem.ycoordinate)) * previreconfig.rowHeight)
                //start middle end
                const textAnchor = fieldItem.fontjustification === "1" ? "start" : fieldItem.fontjustification === "2" ? "middle" : "end"

                if (fieldItem.fieldidentifier.indexOf("avtor") > -1) {
                    cardModelMap[item.carddimensionId].push({
                        tag: "img",
                        x: parseInt(fieldItem.xcoordinate),
                        y: parseInt(fieldItem.ycoordinate),
                        w: parseInt(fieldItem.wide) - 8,
                        h: parseInt(fieldItem.high) - 8,
                        textAnchor: textAnchor,
                        url: (data) => {
                            const showInfo = fieldItem.sampledates ? fieldItem.sampledates[data.infoIndex] : fieldItem.sampledate
                            return window.__kd_cdnPath__ + showInfo + "";
                        },
                    })
                } else {
                    cardModelMap[item.carddimensionId].push({
                        tag: "text",
                        x: parseInt(fieldItem.xcoordinate) + 4,
                        y: parseInt(fieldItem.ycoordinate),
                        w: parseInt(fieldItem.wide) - 8,
                        h: parseInt(fieldItem.high),
                        fontSize: parseInt(fieldItem.wordsize),
                        fontWeight: parseInt(fieldItem.bold) ? 600 : 100,
                        color: "#212121",
                        wMode: "lr",
                        valign: "center",
                        textAnchor: textAnchor,
                        lineNums: 2,
                        text: (data) => {
                            const showInfo = fieldItem.sampledates ? fieldItem.sampledates[data.infoIndex] : fieldItem.sampledate
                            return [(fieldItem.beforecontent || "") + showInfo + (fieldItem.aftercontent || "")];
                        },
                    })
                }
            })

            maxh = Math.max(MaxHeight, maxh)

            cardModelSize[item.carddimensionId] = maxh
        } else {
            cardModelMap[item.carddimensionId] = [defaultCardMode(baseCardSize, afterName)]

            cardModelSize[item.carddimensionId] = baseCardSize.height

            maxh = Math.max(baseCardSize.height, maxh)
        }

        if ((item.carddimensionId + "") == "1010") {
            cardModelMap[item.carddimensionId].push(orgCardNavbar)
        }

        console.log("cardModelMap", cardModelMap);

    })

    baseCardSize.height = maxh

    return [
        cardModelMap,
        baseCardSize,
        cardModelSize
    ]
}

export function getCardStyle(node) {
    let style = {
        background: "#fff",
        border: "#aaa",
        borderType: "",
        radius: 0
    }

    const carddimensionId = node.data.type + ""

    switch (carddimensionId) {
        case "1010":
            break;
        case "1110":
            style.background = "rgba(85, 130, 243, 0.05)"
            style.border = "rgb(85, 130, 243)"
            break;
    }

    if (node.data.dname.indexOf("项目团队") > -1) {
        style.radius = 10
    }

    return style
}